import { intlTelInputComponent } from "./intl-tel-input.component";
import { validatePhoneNumberDirective } from "./validate-phone-number.directive";

export const intlTelInput = angular
  .module("common.libs.intlTelInput", [])
  .directive("validatePhoneNumber", validatePhoneNumberDirective)
  .component("intlTelInput", intlTelInputComponent).name;



// WEBPACK FOOTER //
// ./src/app/common/components/intl-tel-input/intl-tel-input.module.js